import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';
import { classNames } from 'primereact/utils';

type ToolbarChipButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Icon or short label rendered inside the 24x24 chip. */
  children: ReactNode;
};

/**
 * 24x24 white chip button matching the "Clear assigned user" (X) button in
 * CreateEditCaseSidebar. Shared so any inline field-adornment (symbol
 * picker trigger, dictate button, clear-value affordances) reads as one
 * visual system: gray-110 border, gray-50 hover, 24px square, rounded-md.
 *
 * `type="button"` is defaulted so accidental form submits don't happen
 * when this is nested inside a form (as in the chronology dialog).
 */
export const ToolbarChipButton = forwardRef<HTMLButtonElement, ToolbarChipButtonProps>(
  ({ className, children, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={classNames(
        'border-fletchers-gray-110 hover:!bg-fletchers-gray-50 text-fletchers-black-900 flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded-md border bg-white disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);
ToolbarChipButton.displayName = 'ToolbarChipButton';
